import React, { FC } from 'react';

export const IconArrowDownThin: FC<React.PropsWithChildren<{ className?: string }>> = ({ className = '' }) => {
  return (
    <svg className={className} width="9" height="6" viewBox="0 0 9 6" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 1L4.49138 4L7.75 1" stroke="currentColor" strokeWidth="1.5" />
    </svg>
  );
};
